<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_stock_record_viewmanage')">
				<template #search>
					<m-search ref="search" :init-data="initSearchData">
						<m-search-item label="仓库">
							<c-select name="warehouse_ids" async multiple @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="批次号" v-if="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="单据编号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="来源单据号">
							<c-input name="ref_code"></c-input>
						</m-search-item>
						<m-search-item label="库存收发时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier"></c-select>
						</m-search-item>
					</m-search>
				</template>
				<template #operate>
					<c-button v-if="auth('b_stock_record_export')" v-lock="lock('b_stock_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_record_export')" v-lock="lock('b_stock_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_stock_record_export')" v-lock="lock('b_stock_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_record_export')" v-lock="lock('b_stock_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="systemConfig.batch_stock == 1 && auth('b_stock_record_print')" v-lock="lock('b_stock_record_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>
				<!--单据类型-->
				<template #order_type="{data}">
					<c-state dict="orderTypeName" :value="data.order_type"></c-state>
				</template>
				<!--单据编号-->
				<template #order_code="{data}">
					<c-link v-if="auth('m_stockin') && data.order_type==4 && data.order_id && data.order_id>0" @click="globalDialog('stockinDetail', {props: {id: data.order_id}})">{{data.order_code}}</c-link>
					<c-link v-else-if="auth('m_stockout') && data.order_type==5 && data.order_id && data.order_id>0" @click="globalDialog('stockoutDetail', {props: {id: data.order_id}})">{{data.order_code}}</c-link>
					<c-link v-else-if="auth('m_inventory') && data.order_type==6 && data.order_id && data.order_id>0" @click="globalDialog('inventoryDetail', {props: {id: data.order_id}})">{{data.order_code}}</c-link>
				</template>
				<!--库存类型-->
				<template #order_classify="{data}">
					<c-state dict="stockClassifyName" :value="data.order_classify"></c-state>
				</template>
				<!--库存变更数量-->
				<template #stock_change_count="{data}">
					<!--已审核 -->
					<template v-if="data.approve_state == 2">
						<strong v-if="data.stock_change_count &&data.stock_change_count > 0" style="color: green">{{data.stock_change_count}}</strong>
						<strong v-else-if="data.stock_change_count && data.stock_change_count < 0" style="color: red">{{data.stock_change_count}}</strong>
						<span v-else>{{data.stock_change_count}}</span>
					</template>
					<span v-else style="color: #bbb">-</span>
				</template>
				<!--备注-->
				<template #remark="{data}">
					<span v-if="data.remark">{{data.remark}}</span>
					<span v-else>-</span>
				</template>
				<!--关联单据-->
				<template #ref_code="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		props: {
			in_product_code: String
		},
		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig','orderTypeName','stockinClassifyName'])
		},
		data() {
			return {
				workType:16,
				initSearchData: {
					product_code: this.in_product_code||''
				}
			}
		},
		methods: {
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
			    this.request({
			        url:'/system/options',
			        data: {
			            options_code:'SUPPLIER',
			            keyword: keyword
			        },
			        success:data => {
			            resolve(data);
			        }
			    })
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>